var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-6"},[(_vm.loading)?_c('LoadingPage'):_c('div',[_c('ParkingForm',{staticClass:"mb-6",attrs:{"parking":_vm.parkingById}}),_c('SpotList',{attrs:{"attributes":_vm.getAttributes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }